import {useEffect, useState} from "react";
import associateServices from "../../../../services";
import TableFooter from "../../../../components/table-footer/TableFooter";
import Loading from "../../../../components/loading";
import NoData from "../../../../components/no-data";
import moment from "moment";
import Big from "big.js";
import {useNavigate} from "react-router-dom";
import './index.css'
import {useTranslation} from "react-i18next";
import stringHelper from "../../../../helpers/string-helper";

const Raffle = props => {
    const {username} = props
    const [page, setPage] = useState(1)
    const [limit] = useState(3)
    const [data, setData] = useState([])
    const [total, setTotal] = useState([])
    const [loading, setLoading] = useState([])

    const {i18n,t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const navigate = useNavigate()
    useEffect(() => {
        setLoading(true)
        associateServices.getRaffles({
            page, limit,username
        }).then(res => {
            setData(res?.data?.data)
            setTotal(res?.data?.total)
            setLoading(false)
        })
    }, [page, limit])


    const handlePrev = () => {
        setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    }
    const handleNext = () => {
        setPage(prevState => prevState + 1)
    }
    return (
        <div
            className="tab-pane fade show active">

            <div className="row">
                <div className="col-12">
                    <div className="table-responsive">

                        {
                            loading ? <Loading/> : data?.length <= 0 ? <NoData/> :

                                <table className="xtable xtable--modal">
                                    <thead>
                                    <tr>
                                        <th>
                                            {t(`modals.statistics.table.name`)}
                                        </th>
                                        <th>
                                            {t(`modals.statistics.table.date`)}
                                        </th>
                                        <th>
                                            {t(`modals.statistics.table.tickets`)}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {data?.map(item => (
                                        <tr key={item.id}>
                                            <td>
                                                <div className="xtable__text">{item.name}</div>
                                            </td>
                                            <td>
                                                <div className="xtable__text">
                                                    {
                                                        moment.unix(item.end).format("MMM Do YY")
                                                    }
                                                </div>
                                            </td>
                                            <td onClick={e =>
                                                navigate(stringHelper.getLocalizedPath(currentLanguage, `/raffle/${item.uuid}/tickets`))
                                            }>
                                                <div
                                                    className="xtable__text ticket-count">{Big(item.count || 0).toFixed(2)}</div>
                                            </td>
                                        </tr>
                                    ))}


                                    </tbody>
                                </table>
                        }

                    </div>


                    <TableFooter
                        total={total}
                        limit={limit}
                        handlePrev={handlePrev}
                        handleNext={handleNext}
                        page={page}
                        buttonText={null}
                    />
                </div>
            </div>

        </div>

    )

}

export default Raffle
